<template>
    <cadastro-simples-list
        endpoint="criterio-avaliacao"
        rota-base="/admin/criterio-avaliacao"
        titulo="CRITÉRIOS DE AVALIAÇÃO"
        titulo-singular="Critério de Avaliação"
        :colunas-extras='[{"campo":"competencia","label":"Competência","tipo":"string"},{"campo":"peso","label":"Peso","tipo":"string"},{"campo":"ordem","label":"Ordem","tipo":"int"}]'>
    </cadastro-simples-list>
</template>

<script>
import CadastroSimplesList from '@/components/cadastros-auxiliares/cadastro-simples-list.vue'
export default { components: { CadastroSimplesList } }
</script>
